import React from "react";
import { Redirect } from "react-router-dom";
import { history } from "../Layout/Layout";

import CxPDownPage from "../Layout/MainContent/CxPDownPage";
import { checkAMLob } from "utils/checkAMLob";
import { ENDPOINTS } from "utils/endpoints";

const LobWrapper = (
  WirelessComponent,
  WirelineComponent,
  OTTComponent,
  FamilyMoneyComponent,
  VILSComponent,
  CVAComponent,
  FamilyAppComponent
) => {
  const amLob = checkAMLob();

  if (window.profileError) {
    return <CxPDownPage pageContentUrl={ENDPOINTS.FETCH_CXP_DOWN_PAGE} />;
  }

  if (amLob === "vzt") {
    return <WirelineComponent history={history} />;
  } else if (amLob === "ott") {
    return <OTTComponent history={history} />;
  } else if (amLob === "agent") {
    return <Redirect to="/privacy/secure/authorized-agent" />;
  } else if(amLob === "autoapp"){                  //developer Arvind
    return <CVAComponent history={history}/>
  } else if(amLob === "ip"){                    // developer Arvind
    return <FamilyAppComponent history={history}/>
  }else if (amLob === "nico") {
    return <FamilyMoneyComponent history={history} />;
  } else if (amLob === "vils") {
    return <VILSComponent history={history} />;
  }
  return <WirelessComponent history={history} />;
};

export default LobWrapper;
